import {get} from '@/api/request.js'

const url = '/admin/unit'
/**
 * 获取单位
 * @returns {Promise<void>}
 */
export const get_unit = async function () {
    return await get(url)
}

